import {
  apiServer,
  onBoardingAlbumIdForDesktop,
  onBoardingAlbumIdDarkmodeForDesktop,
} from "../config";

export interface OnboardingResult {
  status: string;
  message: string;
  data: OnboardingPhotos[];
}

export interface OnboardingPhotos {
  id: number;
  name: string;
  speed: number;
  delay: number;
  album_type: string;
  active: number;
  created_at: string;
  updated_at: string;
  photos: Photo[];
}

export interface Photo {
  id: number;
  album_id: number;
  image: string;
  alt_text: string;
  position: number;
  created_at: string;
  updated_at: string;
  title: string;
  description?: string;
}

function isMobileBrowser() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export async function loadOnboardingData(isMobile: boolean, isDark: boolean) {
  const response = await fetch(apiServer + "/album/load");
  const data = await response.json();

  if (data.status === "error") {
    throw new Error(data.message);
  } else {
    if (isMobile) {
      // Load the mobile version of the onboarding album
      return data.data[0]; // Fallback to the first album (mobile)
    } else if (onBoardingAlbumIdForDesktop) {
      let targetAlbumId: { toString: () => any };
      if (isDark && onBoardingAlbumIdDarkmodeForDesktop) {
        // Use dark mode album ID for desktop if in dark mode
        targetAlbumId = onBoardingAlbumIdDarkmodeForDesktop;
      } else if (onBoardingAlbumIdForDesktop) {
        // Use regular desktop album ID
        targetAlbumId = onBoardingAlbumIdForDesktop;
      }

      // Load the desktop version of the onboarding album
      const album = data.data.find((album: { id: any }) => {
        return album.id.toString() === targetAlbumId.toString();
      });

      if (album) {
        return album;
      }
    } else {
      return data.data[0]; // Fallback to the first album if no specific desktop album is found
    }
  }
}
